module.exports = require("react-simple-tooltip");